import {
    ROUTE_ADMINISTRATION_GROUP,
    ROUTE_ADMINISTRATION_GROUP_SUCCESS,
    ROUTE_ADMINISTRATION_GROUP_ERROR,
    DOSAGE_FORM_GROUP,
    DOSAGE_FORM_GROUP_SUCCESS,
    DOSAGE_FORM_GROUP_ERROR,
    ROUTE_ADMINISTRATION,
    ROUTE_ADMINISTRATION_SUCCESS,
    ROUTE_ADMINISTRATION_ERROR,
    DOSAGE_FORM,
    DOSAGE_FORM_SUCCESS,
    DOSAGE_FORM_ERROR,
    DISPENSING_UNIT,
    DISPENSING_UNIT_SUCCESS,
    DISPENSING_UNIT_ERROR,
    UNSPSC,
    UNSPSC_SUCCESS,
    UNSPSC_ERROR,
    UNSPSC_FAMILY,
    UNSPSC_FAMILY_SUCCESS,
    UNSPSC_FAMILY_ERROR,
    UNSPSC_CLASS,
    UNSPSC_CLASS_SUCCESS,
    UNSPSC_CLASS_ERROR,
    ACTIVE_INGREDIENT_CODE20,
    ACTIVE_INGREDIENT_CODE20_SUCCESS,
    ACTIVE_INGREDIENT_CODE20_ERROR,
    DOSAGE_FORM_CODE20,
    DOSAGE_FORM_CODE20_SUCCESS,
    DOSAGE_FORM_CODE20_ERROR,
    MED_DESCRIPTION_CODE20,
    MED_DESCRIPTION_CODE20_SUCCESS,
    MED_DESCRIPTION_CODE20_ERROR,
    SOURCE_CODE20,
    SOURCE_CODE20_SUCCESS,
    SOURCE_CODE20_ERROR,
    PROJECT,
    PROJECT_SUCCESS,
    PROJECT_ERROR,
    ARTICLE_CODE22,
    ARTICLE_CODE22_SUCCESS,
    ARTICLE_CODE22_ERROR,
    BIDDER,
    BIDDER_SUCCESS,
    BIDDER_ERROR,
    PROCESS_CODE,
    PROCESS_CODE_SUCCESS,
    PROCESS_CODE_ERROR,
    COUNTRY_BID,
    COUNTRY_BID_SUCCESS,
    COUNTRY_BID_ERROR,
    MED_DESCRIPTION_CODE22,
    MED_DESCRIPTION_CODE22_SUCCESS,
    MED_DESCRIPTION_CODE22_ERROR,
    ARTICLE_TYPE,
    ARTICLE_TYPE_SUCCESS,
    ARTICLE_TYPE_ERROR,
    ARTICLE_GROUP,
    ARTICLE_GROUP_SUCCESS,
    ARTICLE_GROUP_ERROR,
    COUNTRY_SUPPLIER,
    COUNTRY_SUPPLIER_SUCCESS,
    COUNTRY_SUPPLIER_ERROR,
    SUPPLIER_TYPE,
    SUPPLIER_TYPE_SUCCESS,
    SUPPLIER_TYPE_ERROR,
    PUBLICATION_TYPE,
    PUBLICATION_TYPE_SUCCESS,
    PUBLICATION_TYPE_ERROR,
    PUBLICATION_FORMAT,
    PUBLICATION_FORMAT_SUCCESS,
    PUBLICATION_FORMAT_ERROR,
    PUBLICATION_STATUS,
    PUBLICATION_STATUS_SUCCESS,
    PUBLICATION_STATUS_ERROR,
    PUBLICATION_PROJECT,
    PUBLICATION_PROJECT_SUCCESS,
    PUBLICATION_PROJECT_ERROR,
    COUNTRY_OPENNING,
    COUNTRY_OPENNING_SUCCESS,
    COUNTRY_OPENNING_ERROR,
    PROCESS_CODE_BID,
    PROCESS_CODE_BID_SUCCESS,
    PROCESS_CODE_BID_ERROR,
    COUNTRY_SOURCE_CODE22,
    COUNTRY_SOURCE_CODE22_SUCCESS,
    COUNTRY_SOURCE_CODE22_ERROR,
    MED_DESCRIPTION_CODE22_ORP,
    MED_DESCRIPTION_CODE22_ORP_SUCCESS,
    MED_DESCRIPTION_CODE22_ORP_ERROR,
    SOURCE_CODE22,
    SOURCE_CODE22_SUCCESS,
    SOURCE_CODE22_ERROR,
    PROCCESS_YEAR,
    PROCCESS_YEAR_SUCCESS,
    PROCCESS_YEAR_ERROR,
    ANIO_PRICE_CODE22,
    ANIO_PRICE_CODE22_SUCCESS,
    ANIO_PRICE_CODE22_ERROR,
    PROCESS_CODE_BIDDER,
    PROCESS_CODE_BIDDER_SUCCESS,
    PROCESS_CODE_BIDDER_ERROR,
    PROCCESS_YEAR_BIDDER,
    PROCCESS_YEAR_BIDDER_SUCCESS,
    PROCCESS_YEAR_BIDDER_ERROR,
    LOTE_STATE,
    LOTE_STATE_SUCCESS,
    LOTE_STATE_ERROR,
    YEAR_DEMAND,
    YEAR_DEMAND_SUCCESS,
    YEAR_DEMAND_ERROR,
    YEAR_GOB360,
    YEAR_GOB360_SUCCESS,
    YEAR_GOB360_ERROR,
    INSTITUTION_GOB360,
    INSTITUTION_GOB360_SUCCESS,
    INSTITUTION_GOB360_ERROR,
    PROCESS_CODE_OPENING,
    PROCESS_CODE_OPENING_SUCCESS,
    PROCESS_CODE_OPENING_ERROR,
    UNIT_PRICE,
    UNIT_PRICE_SUCCESS,
    UNIT_PRICE_ERROR,
    UNIT_PRICE_TRANSACCIONES,
    UNIT_PRICE_TRANSACCIONES_SUCCESS,
    UNIT_PRICE_TRANSACCIONES_ERROR,
    LIST_ARTICLE_ORP_CODE22,
    LIST_ARTICLE_ORP_CODE22_SUCCESS,
    LIST_ARTICLE_ORP_CODE22_ERROR,
    LIST_ARTICLE_CODE_COUNTRY,
    LIST_ARTICLE_CODE_COUNTRY_SUCCESS,
    LIST_ARTICLE_CODE_COUNTRY_ERROR,
    LIST_ARTICLE_CODE_COUNTRY_BIDDER,
    LIST_ARTICLE_CODE_COUNTRY_BIDDER_SUCCESS,
    LIST_ARTICLE_CODE_COUNTRY_BIDDER_ERROR,
    COUNTRY_TAB_AWARD,
    COUNTRY_TAB_AWARD_SUCCESS,
    COUNTRY_TAB_AWARD_ERROR,
    PROCCESS_CODE_TAB_AWARD,
    PROCCESS_CODE_TAB_AWARD_SUCCESS,
    PROCCESS_CODE_TAB_AWARD_ERROR,
    YEAR_TAB_AWARD,
    YEAR_TAB_AWARD_SUCCESS,
    YEAR_TAB_AWARD_ERROR,
    PROCCESS_CODE_TAB_OPENNING,
    PROCCESS_CODE_TAB_OPENNING_SUCCESS,
    PROCCESS_CODE_TAB_OPENNING_ERROR,
    YEAR_TAB_OPENNING,
    YEAR_TAB_OPENNING_SUCCESS,
    YEAR_TAB_OPENNING_ERROR,
    COUNTRY_TAB_OPENNING,
    COUNTRY_TAB_OPENNING_SUCCESS,
    COUNTRY_TAB_OPENNING_ERROR,
    ARTICLE_CODE22_SUPPLIER,
    ARTICLE_CODE22_SUPPLIER_SUCCESS,
    ARTICLE_CODE22_SUPPLIER_ERROR,
    ARTICLE_CODE_COUNTRY_SUPPLIER,
    ARTICLE_CODE_COUNTRY_SUPPLIER_SUCCESS,
    ARTICLE_CODE_COUNTRY_SUPPLIER_ERROR,
    COUNTRY_SUPPLIER_INFO,
    COUNTRY_SUPPLIER_INFO_SUCCESS,
    COUNTRY_SUPPLIER_INFO_ERROR,
    SUPPLIER_INFO,
    SUPPLIER_INFO_SUCCESS,
    SUPPLIER_INFO_ERROR,
    MED_DESCRIPTION_RAZONABILIDAD,
    MED_DESCRIPTION_RAZONABILIDAD_SUCCESS,
    MED_DESCRIPTION_RAZONABILIDAD_ERROR,
    LIST_ARTICLE_RAZONABILIDAD,
    LIST_ARTICLE_RAZONABILIDAD_SUCCESS,
    LIST_ARTICLE_RAZONABILIDAD_ERROR,
    COUNTRY_AWARD,
    COUNTRY_AWARD_SUCCESS,
    COUNTRY_AWARD_ERROR,
    ROLE,
    ROLE_SUCCESS,
    ROLE_ERROR,
    ROLE_ORP,
    ROLE_ORP_SUCCESS,
    ROLE_ORP_ERROR,

} from '../actions';

const INIT_STATE = {
  modal: false,
  init:true,
    route_administration_group: {
        data: [],
        loading: true,
        message: ''
    },
    dosage_form_group: {
        data: [],
        loading: true,
        message: ''
    },
    route_administration: {
        data: [],
        loading: true,
        message: ''
    },
    dosage_form: {
        data: [],
        loading: true,
        message: ''
    },
    dispensing_unit: {
        data: [],
        loading: true,
        message: ''
    },
    unspsc: {
        data: [],
        loading: true,
        message: ''
    },
    unspsc_family: {
        data: [],
        loading: true,
        message: ''
    },
    unspsc_class: {
        data: [],
        loading: true,
        message: ''
    },
    active_ingredient_code20: {
        data: [],
        loading: true,
        message: ''
    },
    dosage_form_code20: {
        data: [],
        loading: true,
        message: ''
    },
    med_description_code20: {
        data: [],
        loading: true,
        message: ''
    },
    source_code20: {
        data: [],
        loading: true,
        message: ''
    },
    project: {
        data: [],
        loading: true,
        message: ''
    },
    article_code22: {
        data: [],
        loading: true,
        message: ''
    },
    bidder: {
        data: [],
        loading: true,
        message: ''
    },
    process_code: {
        data: [],
        loading: true,
        message: ''
    },
    country_bid: {
        data: [],
        loading: true,
        message: ''
    },
    med_description_code22: {
        data: [],
        loading: true,
        message: ''
    },
    article_type: {
        data: [],
        loading: true,
        message: ''
    },
    article_group: {
        data: [],
        loading: true,
        message: ''
    },
    country_supplier: {
        data: [],
        loading: true,
        message: ''
    },
    supplier_type: {
        data: [],
        loading: true,
        message: ''
    },
    publication_type: {
        data: [],
        loading: true,
        message: ''
    },
    publication_format: {
        data: [],
        loading: true,
        message: ''
    },
    publication_project: {
        data: [],
        loading: true,
        message: ''
    },
    publication_status: {
        data: [],
        loading: true,
        message: ''
    },
    country_openning: {
        data: [],
        loading: true,
        message: ''
    },
    process_code_bid: {
        data: [],
        loading: true,
        message: ''
    },
    country_source_code22: {
        data: [],
        loading: true,
        message: ''
    },
    med_description_code22_orp: {
        data: [],
        loading: true,
        message: ''
    },
    source_code22: {
        data: [],
        loading: true,
        message: ''
    },
    proccess_year: {
        data: [],
        loading: true,
        message: ''
    },
    anio_price_code22: {
        data: [],
        loading: true,
        message: ''
    },
    process_code_bidder: {
        data: [],
        loading: true,
        message: ''
    },
    proccess_year_bidder: {
        data: [],
        loading: true,
        message: ''
    },
    lote_state: {
        data: [],
        loading: true,
        message: ''
    },
    year_demand: {
        data: [],
        loading: true,
        message: ''
    },
    year_gob360: {
        data: [],
        loading: true,
        message: ''
    },
    institution_gob360: {
        data: [],
        loading: true,
        message: ''
    },
    process_code_opening: {
        data: [],
        loading: true,
        message: ''
    },
    unit_price: {
        data: [],
        loading: true,
        message: ''
    },
    unit_price_transacciones: {
        data: [],
        loading: true,
        message: ''
    },
    list_article_orp_code22: {
        data: [],
        loading: true,
        message: ''
    },
    list_article_code_country: {
        data: [],
        loading: true,
        message: ''
    },
    list_article_code_country_bidder: {
        data: [],
        loading: true,
        message: ''
    },
    country_tab_award: {
        data: [],
        loading: true,
        message: ''
    },
    proccess_code_tab_award: {
        data: [],
        loading: true,
        message: ''
    },
    year_tab_award: {
        data: [],
        loading: true,
        message: ''
    },
    proccess_code_tab_openning: {
        data: [],
        loading: true,
        message: ''
    },
    year_tab_openning: {
        data: [],
        loading: true,
        message: ''
    },
    country_tab_openning: {
        data: [],
        loading: true,
        message: ''
    },
    article_code22_supplier: {
        data: [],
        loading: true,
        message: ''
    },
    article_codecountry_supplier: {
        data: [],
        loading: true,
        message: ''
    },
    country_supplier_info: {
        data: [],
        loading: true,
        message: ''
    },
    supplier_info: {
        data: [],
        loading: true,
        message: ''
    },
    med_description_razonabilidad: {
        data: [],
        loading: true,
        message: ''
    },
    list_article_razonabilidad: {
        data: [],
        loading: true,
        message: ''
    },
    country_award: {
        data: [],
        loading: true,
        message: ''
    },
    role: {
        data: [],
        loading: true,
        message: ''
    },
    role_orp: {
        data: [],
        loading: true,
        message: ''
    },
  value:{
      route_administration_group: false,
      dosage_form_group: false,
      route_administration: false,
      dosage_form: false,
      dispensing_unit: false,
      unspsc: false,
      unspsc_family: false,
      unspsc_class: false,
      active_ingredient_code20:false,
      dosage_form_code20: false,
      med_description_code20: false,
      source_code20: false,
      project: false,
      article_code22: false,
      bidder: false,
      process_code: false,
      country_bid: false,
      med_description_code22: false,
      article_type: false,
      article_group: false,
      country_supplier: false,
      supplier_type: false,
      publication_type: false,
      publication_format: false,
      publication_status: false,
      publication_project: false,
      country_openning: false,
      process_code_bid: false,
      country_source_code22: false,
      med_description_code22_orp: false,
      source_code22: false,
      proccess_year: false,
      anio_price_code22: false,
      process_code_bidder: false,
      proccess_year_bidder: false,
      country_bidder: false,
      lote_state: false,
      year_demand: false,
      year_gob360: false,
      institution_gob360: false,
      process_code_opening: false,
      unit_price: false,
      unit_price_transacciones: false,
      idcode22:false
    }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
      case ROUTE_ADMINISTRATION_GROUP:
      return {
        ...state,
        init:false,
          route_administration_group:{
              ...state.route_administration_group,
          loading: true,
          data:[],
          message: ''
        }
      }
      case ROUTE_ADMINISTRATION_GROUP_SUCCESS:
      return {
        ...state,
          route_administration_group:{
              ...state.route_administration_group,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
      case ROUTE_ADMINISTRATION_GROUP_ERROR:
      return {
        ...state,
          route_administration_group:{
              ...state.route_administration_group,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }

      case DOSAGE_FORM_GROUP:
          return {
              ...state,
              init: false,
              dosage_form_group: {
                  ...state.dosage_form_group,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case DOSAGE_FORM_GROUP_SUCCESS:
          return {
              ...state,
              dosage_form_group: {
                  ...state.dosage_form_group,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case DOSAGE_FORM_GROUP_ERROR:
          return {
              ...state,
              dosage_form_group: {
                  ...state.dosage_form_group,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
        case ROUTE_ADMINISTRATION:
            return {
                ...state,
                init: false,
                route_administration: {
                    ...state.route_administration,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case ROUTE_ADMINISTRATION_SUCCESS:
            return {
                ...state,
                route_administration: {
                    ...state.route_administration,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case ROUTE_ADMINISTRATION_ERROR:
            return {
                ...state,
                route_administration: {
                    ...state.route_administration,
                    loading: false,
                    data: [],
                    message: 'No se encotraron datos'
                }
            }

        case DOSAGE_FORM:
            return {
                ...state,
                init: false,
                dosage_form: {
                    ...state.dosage_form,
                    loading: true,
                    data: [],
                    message: ''
                }
            }
        case DOSAGE_FORM_SUCCESS:
            return {
                ...state,
                dosage_form: {
                    ...state.dosage_form,
                    loading: false,
                    data: action.payload,
                    message: ''
                }
            }
        case DOSAGE_FORM_ERROR:
            return {
                ...state,
                dosage_form: {
                    ...state.dosage_form,
                    loading: false,
                    data: [],
                    message: 'No se encotraron datos'
                }
          }
      case DISPENSING_UNIT:
          return {
              ...state,
              init: false,
              dispensing_unit: {
                  ...state.dispensing_unit,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case DISPENSING_UNIT_SUCCESS:
          return {
              ...state,
              dispensing_unit: {
                  ...state.dispensing_unit,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case DISPENSING_UNIT_ERROR:
          return {
              ...state,
              dispensing_unit: {
                  ...state.dispensing_unit,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case UNSPSC:
          return {
              ...state,
              init: false,
              unspsc: {
                  ...state.unspsc,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case UNSPSC_SUCCESS:
          return {
              ...state,
              unspsc: {
                  ...state.unspsc,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case UNSPSC_ERROR:
          return {
              ...state,
              unspsc: {
                  ...state.unspsc,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case UNSPSC_FAMILY:
          return {
              ...state,
              init: false,
              unspsc_family: {
                  ...state.unspsc_family,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case UNSPSC_FAMILY_SUCCESS:
          return {
              ...state,
              unspsc_family: {
                  ...state.unspsc_family,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case UNSPSC_FAMILY_ERROR:
          return {
              ...state,
              unspsc_family: {
                  ...state.unspsc_family,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case UNSPSC_CLASS:
          return {
              ...state,
              init: false,
              unspsc_class: {
                  ...state.unspsc_class,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case UNSPSC_CLASS_SUCCESS:
          return {
              ...state,
              unspsc_class: {
                  ...state.unspsc_class,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case UNSPSC_CLASS_ERROR:
          return {
              ...state,
              unspsc_class: {
                  ...state.unspsc_class,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ACTIVE_INGREDIENT_CODE20:
          return {
              ...state,
              init: false,
              active_ingredient_code20: {
                  ...state.active_ingredient_code20,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case ACTIVE_INGREDIENT_CODE20_SUCCESS:
          return {
              ...state,
              active_ingredient_code20: {
                  ...state.active_ingredient_code20,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case ACTIVE_INGREDIENT_CODE20_ERROR:
          return {
              ...state,
              active_ingredient_code20: {
                  ...state.active_ingredient_code20,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case DOSAGE_FORM_CODE20:
          return {
              ...state,
              init: false,
              dosage_form_code20: {
                  ...state.dosage_form_code20,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case DOSAGE_FORM_CODE20_SUCCESS:
          return {
              ...state,
              dosage_form_code20: {
                  ...state.dosage_form_code20,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case DOSAGE_FORM_CODE20_ERROR:
          return {
              ...state,
              dosage_form_code20: {
                  ...state.dosage_form_code20,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case MED_DESCRIPTION_CODE20: 
          return {
              ...state,
              init: false,
              med_description_code20: {
                  ...state.med_description_code20,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case MED_DESCRIPTION_CODE20_SUCCESS: 
          return {
              ...state,
              med_description_code20: {
                  ...state.med_description_code20,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case MED_DESCRIPTION_CODE20_ERROR: 
          return {
              ...state,
              med_description_code20: {
                  ...state.med_description_code20,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case SOURCE_CODE20:
          return {
              ...state,
              init: false,
              source_code20: {
                  ...state.source_code20,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case SOURCE_CODE20_SUCCESS:
          return {
              ...state,
              source_code20: {
                  ...state.source_code20,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case SOURCE_CODE20_ERROR:
          return {
              ...state,
              source_code20: {
                  ...state.source_code20,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case PROJECT:
          return {
              ...state,
              init: false,
              project: {
                  ...state.project,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case PROJECT_SUCCESS:
          return {
              ...state,
              project: {
                  ...state.project,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case PROJECT_ERROR:
          return {
              ...state,
              project: {
                  ...state.project,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ARTICLE_CODE22:
          return {
              ...state,
              init: false,
              article_code22: {
                  ...state.article_code22,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case ARTICLE_CODE22_SUCCESS:
          return {
              ...state,
              article_code22: {
                  ...state.article_code22,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case ARTICLE_CODE22_ERROR:
          return {
              ...state,
              article_code22: {
                  ...state.article_code22,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case BIDDER:
          return {
              ...state,
              init: false,
              bidder: {
                  ...state.bidder,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case BIDDER_SUCCESS:
          return {
              ...state,
              bidder: {
                  ...state.bidder,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case BIDDER_ERROR:
          return {
              ...state,
              bidder: {
                  ...state.bidder,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case PROCESS_CODE:
          return {
              ...state,
              init: false,
              process_code: {
                  ...state.process_code,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case PROCESS_CODE_SUCCESS:
          return {
              ...state,
              process_code: {
                  ...state.process_code,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case PROCESS_CODE_ERROR:
          return {
              ...state,
              process_code: {
                  ...state.process_code,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case COUNTRY_BID:
          return {
              ...state,
              init: false,
              country_bid: {
                  ...state.country_bid,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case COUNTRY_BID_SUCCESS:
          return {
              ...state,
              country_bid: {
                  ...state.country_bid,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case COUNTRY_BID_ERROR:
          return {
              ...state,
              country_bid: {
                  ...state.country_bid,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case MED_DESCRIPTION_CODE22:
          return {
              ...state,
              init: false,
              med_description_code22: {
                  ...state.med_description_code22,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case MED_DESCRIPTION_CODE22_SUCCESS:
          return {
              ...state,
              med_description_code22: {
                  ...state.med_description_code22,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case MED_DESCRIPTION_CODE22_ERROR:
          return {
              ...state,
              med_description_code22: {
                  ...state.med_description_code22,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ARTICLE_TYPE:
          return {
              ...state,
              init: false,
              article_type: {
                  ...state.article_type,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case ARTICLE_TYPE_SUCCESS:
          return {
              ...state,
              article_type: {
                  ...state.article_type,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case ARTICLE_TYPE_ERROR:
          return {
              ...state,
              article_type: {
                  ...state.article_type,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ARTICLE_GROUP:
          return {
              ...state,
              init: false,
              article_group: {
                  ...state.article_group,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case ARTICLE_GROUP_SUCCESS:
          return {
              ...state,
              article_group: {
                  ...state.article_group,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case ARTICLE_GROUP_ERROR:
          return {
              ...state,
              article_group: {
                  ...state.article_group,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case COUNTRY_SUPPLIER:
          return {
              ...state,
              init: false,
              country_supplier: {
                  ...state.country_supplier,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case COUNTRY_SUPPLIER_SUCCESS:
          return {
              ...state,
              country_supplier: {
                  ...state.country_supplier,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case COUNTRY_SUPPLIER_ERROR:
          return {
              ...state,
              country_supplier: {
                  ...state.country_supplier,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case SUPPLIER_TYPE:
          return {
              ...state,
              init: false,
              supplier_type: {
                  ...state.supplier_type,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case SUPPLIER_TYPE_SUCCESS:
          return {
              ...state,
              supplier_type: {
                  ...state.supplier_type,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case SUPPLIER_TYPE_ERROR:
          return {
              ...state,
              supplier_type: {
                  ...state.supplier_type,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case PUBLICATION_TYPE:
          return {
              ...state,
              init: false,
              publication_type: {
                  ...state.publication_type,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case PUBLICATION_TYPE_SUCCESS:
          return {
              ...state,
              publication_type: {
                  ...state.publication_type,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case PUBLICATION_TYPE_ERROR:
          return {
            ...state,
            publication_type: {
                ...state.publication_type,
                loading: false,
                data: [],
                message: 'No se encotraron datos'
            }
        }

    case PUBLICATION_FORMAT:
        return {
            ...state,
            init: false,
            publication_format: {
                ...state.publication_format,
                loading: true,
                data: [],
                message: ''
            }
        }

    case PUBLICATION_FORMAT_SUCCESS:
        return {
            ...state,
            publication_format: {
                ...state.publication_format,
                loading: false,
                data: action.payload,
                message: ''
            }
        }

    case PUBLICATION_FORMAT_ERROR:
        return {
            ...state,
            publication_format: {
                ...state.publication_format,
                loading: false,
                data: [],
                message: 'No se encotraron datos'
            }
        }

      case PUBLICATION_STATUS:
        return {
            ...state,
            init: false,
            publication_status: {
                ...state.publication_status,
                loading: true,
                data: [],
                message: ''
            }
        }

      case PUBLICATION_STATUS_SUCCESS:
        return {
            ...state,
            publication_status: {
                ...state.publication_status,
                loading: false,
                data: action.payload,
                message: ''
            }
        }

      case PUBLICATION_STATUS_ERROR:
        return {
            ...state,
            publication_status: {
                ...state.publication_status,
                loading: false,
                data: [],
                message: 'No se encotraron datos'
            }
        }

      case PUBLICATION_PROJECT:
          return {
              ...state,
              init: false,
              publication_project: {
                  ...state.publication_project,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case PUBLICATION_PROJECT_SUCCESS:
          return {
              ...state,
              publication_project: {
                  ...state.publication_project,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case PUBLICATION_PROJECT_ERROR:
          return {
              ...state,
              publication_project: {
                  ...state.publication_project,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case COUNTRY_OPENNING:
          return {
              ...state,
              init: false,
              country_openning: {
                  ...state.country_openning,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case COUNTRY_OPENNING_SUCCESS:
          return {
              ...state,
              country_openning: {
                  ...state.country_openning,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case COUNTRY_OPENNING_ERROR:
          return {
              ...state,
              country_openning: {
                  ...state.country_openning,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case PROCESS_CODE_BID:
          return {
              ...state,
              init: false,
              process_code_bid: {
                  ...state.process_code_bid,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case PROCESS_CODE_BID_SUCCESS:
          return {
              ...state,
              process_code_bid: {
                  ...state.process_code_bid,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case PROCESS_CODE_BID_ERROR:
          return {
              ...state,
              process_code_bid: {
                  ...state.process_code_bid,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case COUNTRY_SOURCE_CODE22:
          return {
              ...state,
              init: false,
              country_source_code22: {
                  ...state.country_source_code22,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case COUNTRY_SOURCE_CODE22_SUCCESS:
          return {
              ...state,
              country_source_code22: {
                  ...state.country_source_code22,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case COUNTRY_SOURCE_CODE22_ERROR:
          return {
              ...state,
              country_source_code22: {
                  ...state.country_source_code22,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case MED_DESCRIPTION_CODE22_ORP:
          return {
              ...state,
              init: false,
              med_description_code22_orp: {
                  ...state.med_description_code22_orp,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case MED_DESCRIPTION_CODE22_ORP_SUCCESS:
          return {
              ...state,
              med_description_code22_orp: {
                  ...state.med_description_code22_orp,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case MED_DESCRIPTION_CODE22_ORP_ERROR:
          return {
              ...state,
              med_description_code22_orp: {
                  ...state.med_description_code22_orp,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case SOURCE_CODE22:
          return {
              ...state,
              init: false,
              source_code22: {
                  ...state.source_code22,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case SOURCE_CODE22_SUCCESS:
          return {
              ...state,
              source_code22: {
                  ...state.source_code22,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case SOURCE_CODE22_ERROR:
          return {
              ...state,
              source_code22: {
                  ...state.source_code22,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case PROCCESS_YEAR:
          return {
              ...state,
              init: false,
              proccess_year: {
                  ...state.proccess_year,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case PROCCESS_YEAR_SUCCESS:
          return {
              ...state,
              proccess_year: {
                  ...state.proccess_year,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case PROCCESS_YEAR_ERROR:
          return {
              ...state,
              proccess_year: {
                  ...state.proccess_year,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ANIO_PRICE_CODE22:
          return {
              ...state,
              init: false,
              anio_price_code22: {
                  ...state.anio_price_code22,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case ANIO_PRICE_CODE22_SUCCESS:
          return {
              ...state,
              anio_price_code22: {
                  ...state.anio_price_code22,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case ANIO_PRICE_CODE22_ERROR:
          return {
              ...state,
              anio_price_code22: {
                  ...state.anio_price_code22,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case PROCESS_CODE_BIDDER:
          return {
              ...state,
              init: false,
              process_code_bidder: {
                  ...state.process_code_bidder,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case PROCESS_CODE_BIDDER_SUCCESS:
          return {
              ...state,
              process_code_bidder: {
                  ...state.process_code_bidder,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case PROCESS_CODE_BIDDER_ERROR:
          return {
              ...state,
              process_code_bidder: {
                  ...state.process_code_bidder,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case PROCCESS_YEAR_BIDDER:
          return {
              ...state,
              init: false,
              proccess_year_bidder: {
                  ...state.proccess_year_bidder,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case PROCCESS_YEAR_BIDDER_SUCCESS:
          return {
              ...state,
              proccess_year_bidder: {
                  ...state.proccess_year_bidder,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case PROCCESS_YEAR_BIDDER_ERROR:
          return {
              ...state,
              proccess_year_bidder: {
                  ...state.proccess_year_bidder,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case LOTE_STATE:
          return {
              ...state,
              init: false,
              lote_state: {
                  ...state.lote_state,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case LOTE_STATE_SUCCESS:
          return {
              ...state,
              lote_state: {
                  ...state.lote_state,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case LOTE_STATE_ERROR:
          return {
              ...state,
              lote_state: {
                  ...state.lote_state,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case YEAR_DEMAND:
          return {
              ...state,
              init: false,
              year_demand: {
                  ...state.year_demand,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case YEAR_DEMAND_SUCCESS:
          return {
              ...state,
              year_demand: {
                  ...state.year_demand,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case YEAR_DEMAND_ERROR:
          return {
              ...state,
              year_demand: {
                  ...state.year_demand,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case YEAR_GOB360:
          return {
              ...state,
              init: false,
              year_gob360: {
                  ...state.year_gob360,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case YEAR_GOB360_SUCCESS:
          return {
              ...state,
              year_gob360: {
                  ...state.year_gob360,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case YEAR_GOB360_ERROR:
          return {
              ...state,
              year_gob360: {
                  ...state.year_gob360,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case INSTITUTION_GOB360:
          return {
              ...state,
              init: false,
              institution_gob360: {
                  ...state.institution_gob360,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case INSTITUTION_GOB360_SUCCESS:
          return {
              ...state,
              institution_gob360: {
                  ...state.institution_gob360,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case INSTITUTION_GOB360_ERROR:
          return {
              ...state,
              institution_gob360: {
                  ...state.institution_gob360,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case PROCESS_CODE_OPENING:
          return {
              ...state,
              init: false,
              process_code_opening: {
                  ...state.process_code_opening,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case PROCESS_CODE_OPENING_SUCCESS:
          return {
              ...state,
              process_code_opening: {
                  ...state.process_code_opening,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case PROCESS_CODE_OPENING_ERROR:
          return {
              ...state,
              process_code_opening: {
                  ...state.process_code_opening,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case UNIT_PRICE:
          return {
              ...state,
              init: false,
              unit_price: {
                  ...state.unit_price,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case UNIT_PRICE_SUCCESS:
          return {
              ...state,
              unit_price: {
                  ...state.unit_price,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case UNIT_PRICE_ERROR:
          return {
              ...state,
              unit_price: {
                  ...state.unit_price,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case UNIT_PRICE_TRANSACCIONES:
          return {
              ...state,
              init: false,
              unit_price_transacciones: {
                  ...state.unit_price_transacciones,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case UNIT_PRICE_TRANSACCIONES_SUCCESS:
          return {
              ...state,
              unit_price_transacciones: {
                  ...state.unit_price_transacciones,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case UNIT_PRICE_TRANSACCIONES_ERROR:
          return {
              ...state,
              unit_price_transacciones: {
                  ...state.unit_price_transacciones,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case LIST_ARTICLE_ORP_CODE22:
          return {
              ...state,
              init: false,
              list_article_orp_code22: {
                  ...state.list_article_orp_code22,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case LIST_ARTICLE_ORP_CODE22_SUCCESS:
          return {
              ...state,
              list_article_orp_code22: {
                  ...state.list_article_orp_code22,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case LIST_ARTICLE_ORP_CODE22_ERROR:
          return {
              ...state,
              list_article_orp_code22: {
                  ...state.list_article_orp_code22,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case LIST_ARTICLE_CODE_COUNTRY:
          return {
              ...state,
              init: false,
              list_article_code_country: {
                  ...state.list_article_code_country,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case LIST_ARTICLE_CODE_COUNTRY_SUCCESS:
          return {
              ...state,
              list_article_code_country: {
                  ...state.list_article_code_country,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case LIST_ARTICLE_CODE_COUNTRY_ERROR:
          return {
              ...state,
              list_article_code_country: {
                  ...state.list_article_code_country,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case LIST_ARTICLE_CODE_COUNTRY_BIDDER:
          return {
              ...state,
              init: false,
              list_article_code_country_bidder: {
                  ...state.list_article_code_country_bidder,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case LIST_ARTICLE_CODE_COUNTRY_BIDDER_SUCCESS:
          return {
              ...state,
              list_article_code_country_bidder: {
                  ...state.list_article_code_country_bidder,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case LIST_ARTICLE_CODE_COUNTRY_BIDDER_ERROR:
          return {
              ...state,
              list_article_code_country_bidder: {
                  ...state.list_article_code_country_bidder,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case COUNTRY_TAB_AWARD:
          return {
              ...state,
              init: false,
              country_tab_award: {
                  ...state.country_tab_award,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case COUNTRY_TAB_AWARD_SUCCESS:
          return {
              ...state,
              country_tab_award: {
                  ...state.country_tab_award,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case COUNTRY_TAB_AWARD_ERROR:
          return {
              ...state,
              country_tab_award: {
                  ...state.country_tab_award,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case PROCCESS_CODE_TAB_AWARD:
          return {
              ...state,
              init: false,
              proccess_code_tab_award: {
                  ...state.proccess_code_tab_award,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case PROCCESS_CODE_TAB_AWARD_SUCCESS:
          return {
              ...state,
              proccess_code_tab_award: {
                  ...state.proccess_code_tab_award,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case PROCCESS_CODE_TAB_AWARD_ERROR:
          return {
              ...state,
              proccess_code_tab_award: {
                  ...state.proccess_code_tab_award,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case YEAR_TAB_AWARD:
          return {
              ...state,
              init: false,
              year_tab_award: {
                  ...state.year_tab_award,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case YEAR_TAB_AWARD_SUCCESS:
          return {
              ...state,
              year_tab_award: {
                  ...state.year_tab_award,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case YEAR_TAB_AWARD_ERROR:
          return {
              ...state,
              year_tab_award: {
                  ...state.year_tab_award,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case PROCCESS_CODE_TAB_OPENNING:
          return {
              ...state,
              init: false,
              proccess_code_tab_openning: {
                  ...state.proccess_code_tab_openning,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case PROCCESS_CODE_TAB_OPENNING_SUCCESS:
          return {
              ...state,
              proccess_code_tab_openning: {
                  ...state.proccess_code_tab_openning,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case PROCCESS_CODE_TAB_OPENNING_ERROR:
          return {
              ...state,
              proccess_code_tab_openning: {
                  ...state.proccess_code_tab_openning,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case COUNTRY_TAB_OPENNING:
          return {
              ...state,
              init: false,
              country_tab_openning: {
                  ...state.country_tab_openning,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case COUNTRY_TAB_OPENNING_SUCCESS:
          return {
              ...state,
              country_tab_openning: {
                  ...state.country_tab_openning,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case COUNTRY_TAB_OPENNING_ERROR:
          return {
              ...state,
              country_tab_openning: {
                  ...state.country_tab_openning,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case YEAR_TAB_OPENNING:
          return {
              ...state,
              init: false,
              year_tab_openning: {
                  ...state.year_tab_openning,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case YEAR_TAB_OPENNING_SUCCESS:
          return {
              ...state,
              year_tab_openning: {
                  ...state.year_tab_openning,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case YEAR_TAB_OPENNING_ERROR:
          return {
              ...state,
              year_tab_openning: {
                  ...state.year_tab_openning,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ARTICLE_CODE22_SUPPLIER:
          return {
              ...state,
              init: false,
              article_code22_supplier: {
                  ...state.article_code22_supplier,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case ARTICLE_CODE22_SUPPLIER_SUCCESS:
          return {
              ...state,
              article_code22_supplier: {
                  ...state.article_code22_supplier,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case ARTICLE_CODE22_SUPPLIER_ERROR:
          return {
              ...state,
              article_code22_supplier: {
                  ...state.article_code22_supplier,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ARTICLE_CODE_COUNTRY_SUPPLIER:
          return {
              ...state,
              init: false,
              article_codecountry_supplier: {
                  ...state.article_codecountry_supplier,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case ARTICLE_CODE_COUNTRY_SUPPLIER_SUCCESS:
          return {
              ...state,
              article_codecountry_supplier: {
                  ...state.article_codecountry_supplier,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case ARTICLE_CODE_COUNTRY_SUPPLIER_ERROR:
          return {
              ...state,
              article_codecountry_supplier: {
                  ...state.article_codecountry_supplier,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }

      case COUNTRY_SUPPLIER_INFO:
          return {
              ...state,
              init: false,
              country_supplier_info: {
                  ...state.country_supplier_info,
                  loading: true,
                  data: [],
                  message: ''
              }
          }

      case COUNTRY_SUPPLIER_INFO_SUCCESS:
          return {
              ...state,
              country_supplier_info: {
                  ...state.country_supplier_info,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }

      case COUNTRY_SUPPLIER_INFO_ERROR:
          return {
              ...state,
              country_supplier_info: {
                  ...state.country_supplier_info,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case SUPPLIER_INFO:
          return {
              ...state,
              init: false,
              supplier_info: {
                  ...state.supplier_info,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case SUPPLIER_INFO_SUCCESS:
          return {
              ...state,
              supplier_info: {
                  ...state.supplier_info,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case SUPPLIER_INFO_ERROR:
          return {
              ...state,
              supplier_info: {
                  ...state.supplier_info,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case MED_DESCRIPTION_RAZONABILIDAD:
          return {
              ...state,
              init: false,
              med_description_razonabilidad: {
                  ...state.med_description_razonabilidad,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case MED_DESCRIPTION_RAZONABILIDAD_SUCCESS:
          return {
              ...state,
              med_description_razonabilidad: {
                  ...state.med_description_razonabilidad,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case MED_DESCRIPTION_RAZONABILIDAD_ERROR:
          return {
              ...state,
              med_description_razonabilidad: {
                  ...state.med_description_razonabilidad,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case LIST_ARTICLE_RAZONABILIDAD:
          return {
              ...state,
              init: false,
              list_article_razonabilidad: {
                  ...state.list_article_razonabilidad,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case LIST_ARTICLE_RAZONABILIDAD_SUCCESS:
          return {
              ...state,
              list_article_razonabilidad: {
                  ...state.list_article_razonabilidad,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case LIST_ARTICLE_RAZONABILIDAD_ERROR:
          return {
              ...state,
              list_article_razonabilidad: {
                  ...state.list_article_razonabilidad,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case COUNTRY_AWARD:
          return {
              ...state,
              init: false,
              country_award: {
                  ...state.country_award,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case COUNTRY_AWARD_SUCCESS:
          return {
              ...state,
              country_award: {
                  ...state.country_award,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case COUNTRY_AWARD_ERROR:
          return {
              ...state,
              country_award: {
                  ...state.country_award,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ROLE:
          return {
              ...state,
              init: false,
              role: {
                  ...state.role,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case ROLE_SUCCESS:
          return {
              ...state,
              role: {
                  ...state.role,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case ROLE_ERROR:
          return {
              ...state,
              role: {
                  ...state.role,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
      case ROLE_ORP:
          return {
              ...state,
              init: false,
              role_orp: {
                  ...state.role_orp,
                  loading: true,
                  data: [],
                  message: ''
              }
          }
      case ROLE_ORP_SUCCESS:
          return {
              ...state,
              role_orp: {
                  ...state.role_orp,
                  loading: false,
                  data: action.payload,
                  message: ''
              }
          }
      case ROLE_ORP_ERROR:
          return {
              ...state,
              role_orp: {
                  ...state.role_orp,
                  loading: false,
                  data: [],
                  message: 'No se encotraron datos'
              }
          }
    default:
      return { ...state };
  }
};